import Main from "./Main/MainLayout"

export const MainLayout = Main